import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { KruseCredentialsInputDTORuntype, KruseResponseBodyDTORuntype } from './kruseBackendTypes';

export const kruseEndpoints = {
    'GET /3rdparty/kruse/credentials': endpoint({
        description: 'Returns credentials for Kruse integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: KruseResponseBodyDTORuntype,
    }),
    'POST /3rdparty/kruse/credentials': endpoint({
        description: 'Uploads credentials for Kruse API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: KruseCredentialsInputDTORuntype,
        responseBody: KruseResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/kruse/credentials'],
    }),
    'PATCH /3rdparty/kruse/credentials': endpoint({
        description: 'Updates credentials for Kruse API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: KruseCredentialsInputDTORuntype,
        responseBody: KruseResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/kruse/credentials'],
    }),
    'DELETE /3rdparty/kruse/credentials': endpoint({
        description: 'Deletes existing credentials for Kruse API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/kruse/credentials'],
    }),
};
